// extracted by mini-css-extract-plugin
export default {"event-id":"styles_event-id__DlpZy","skeleton":"styles_skeleton__Juc6Z","shimmer":"styles_shimmer__wM0Ok"};